export const CAPABILITIES = [
  "business.read",
  "business.settings.manage",
  "membership.read",
  "membership.invite",
  "membership.role.assign",
  "order.read",
  "order.create",
  "order.confirm",
  "order.cancel",
  "order.price.override",
  "dispatch.read",
  "dispatch.assign",
  "dispatch.reassign",
  "workshop.intake",
  "workshop.stage.change",
  "workshop.quality.approve",
  "driver.read",
  "driver.location.read",
  "driver.location.write",
  "finance.read",
  "finance.invoice.create",
  "finance.payment.confirm",
  "finance.refund",
  "audit.read",
  "messaging.read",
  "messaging.send",
  "platform.business.approve",
] as const;

export type Capability = (typeof CAPABILITIES)[number];

export const SYSTEM_ROLE_KEYS = [
  "owner",
  "operations_manager",
  "finance_manager",
  "workshop_manager",
  "driver",
] as const;

export type SystemRoleKey = (typeof SYSTEM_ROLE_KEYS)[number];

export const ROLE_CAPABILITY_MATRIX = Object.freeze({
  operations_manager: Object.freeze([
    "business.read",
    "membership.read",
    "order.read",
    "order.create",
    "order.confirm",
    "order.cancel",
    "order.price.override",
    "dispatch.read",
    "dispatch.assign",
    "dispatch.reassign",
    "driver.read",
    "driver.location.read",
    "messaging.read",
    "messaging.send",
  ]),
  finance_manager: Object.freeze([
    "business.read",
    "finance.read",
    "finance.invoice.create",
    "finance.payment.confirm",
    "finance.refund",
    "order.read",
    "audit.read",
    "messaging.read",
    "messaging.send",
  ]),
  workshop_manager: Object.freeze([
    "business.read",
    "workshop.intake",
    "workshop.stage.change",
    "workshop.quality.approve",
    "order.read",
    "order.confirm",
    "messaging.read",
    "messaging.send",
  ]),
  driver: Object.freeze([
    "driver.read",
    "driver.location.write",
    "dispatch.read",
    "order.read",
    "messaging.read",
    "messaging.send",
  ]),
} as const satisfies Readonly<
  Record<Exclude<SystemRoleKey, "owner">, readonly Capability[]>
>);
